import React, { Fragment, useEffect, useState } from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import Link from 'react-router/lib/Link';
import MessageBox from 'components/MessageBox';
import TreatmentStepCard from 'components/TreatmentProtocols/TreatmentStepCard';
// endpoints
import { getGroupDCTreatmentProtocolProductSteps } from 'endpoints/treatmentProtocols';

// Steps due today for a live checkup. A barn-sheet correction gets the steps that covered the
// checkup's date instead (completed protocols included), offered with an explicit Report button
const TreatmentProtocolsProductSteps = ({
  checkupId,
  date,
  isEditMode = false,
  pigGroup,
  selectedStepIds,
  onReport,
}) => {
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    if (pigGroup?.id) {
      const params = isEditMode && date ? { date } : undefined;
      getGroupDCTreatmentProtocolProductSteps(pigGroup.id, params).then((response) => {
        setSteps(response.resources);
      });
    }
  }, [pigGroup?.id, isEditMode, date]);

  return (
    <Fragment>
      {steps.length > 0 && (
        <MessageBox type="warning" className="mb-10">
          {isEditMode ? (
            <FormattedMessage id="component.checkupSegment.correctionProtocolSteps" />
          ) : (
            <FormattedMessage
              id="component.checkupSegment.goToTreatmentsTab"
              values={{
                a: (msg) => <Link className="primary" to={`/daily-checkup/${checkupId}/treatments`}>{msg}</Link>,
              }}
            />
          )}
        </MessageBox>
      )}
      {steps.map((step) => !selectedStepIds.includes(step.id) && (
        <TreatmentStepCard
          key={step.id}
          hasNoDetails
          reportSteps={!isEditMode}
          asOf={isEditMode ? date : undefined}
          className="mt-10 mb-20"
          onReport={onReport}
          pigGroup={pigGroup}
          treatmentStepData={step}
        />
      ))}
    </Fragment>
  );
};

TreatmentProtocolsProductSteps.propTypes = {
  onReport: T.func.isRequired,
  checkupId: T.number,
  date: T.string,
  isEditMode: T.bool,
  pigGroup: T.object,
  selectedStepIds: T.array.isRequired,
};

export default TreatmentProtocolsProductSteps;
